// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3ELqv","right":"Footer_right__31fmx","buttons":"Footer_buttons__eKKBP"};